const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class EmpresaApi {
  async getAllEmpresas() {
    const res = await fetch(api('empresa'));
    if (!res.ok) throw new Error(`getAllEmpresas: ${res.status}`);
    return res.json();
  }

  async getEmpresaById(id) {
    const res = await fetch(api(`empresa/${id}`));
    if (!res.ok) throw new Error(`getEmpresaById: ${res.status}`);
    return res.json();
  }

  async addEmpresa(data) {
    const res = await fetch(api('empresa'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`addEmpresa: ${res.status}`);
    return res.json();
  }

  async updateEmpresa(id, data) {
    const res = await fetch(api(`empresa/${id}`), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`updateEmpresa: ${res.status}`);
    return res.json();
  }

  async deleteEmpresa(id) {
    const res = await fetch(api(`empresa/${id}`), { method: 'DELETE' });
    if (!res.ok) throw new Error(`deleteEmpresa: ${res.status}`);
    return { success: true };
  }
}
